import { useSession } from 'next-auth/react'
import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useQuery } from '@tanstack/react-query'

export const useCurrentUser = () => {
  const { data, status } = useSession()
  const { data: currentUser } = useQuery(queries.user.currentUser())

  const user = {
    ...currentUser,
    provider: data?.user?.account?.provider,
    providerEmail: data?.user?.email,
  }

  return { user, status }
}
